/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { App } from '../models/app';
import { appControllerCreate } from '../fn/app/app-controller-create';
import { AppControllerCreate$Params } from '../fn/app/app-controller-create';
import { appControllerFindApp } from '../fn/app/app-controller-find-app';
import { AppControllerFindApp$Params } from '../fn/app/app-controller-find-app';
import { appControllerFindAppByLanguage } from '../fn/app/app-controller-find-app-by-language';
import { AppControllerFindAppByLanguage$Params } from '../fn/app/app-controller-find-app-by-language';
import { appControllerFindAppWithAccounts } from '../fn/app/app-controller-find-app-with-accounts';
import { AppControllerFindAppWithAccounts$Params } from '../fn/app/app-controller-find-app-with-accounts';
import { appControllerFindEditorAppLabList } from '../fn/app/app-controller-find-editor-app-lab-list';
import { AppControllerFindEditorAppLabList$Params } from '../fn/app/app-controller-find-editor-app-lab-list';
import { appControllerFindEditorAppList } from '../fn/app/app-controller-find-editor-app-list';
import { AppControllerFindEditorAppList$Params } from '../fn/app/app-controller-find-editor-app-list';
import { appControllerFindSupportedAppList } from '../fn/app/app-controller-find-supported-app-list';
import { AppControllerFindSupportedAppList$Params } from '../fn/app/app-controller-find-supported-app-list';
import { appControllerFindTeacherExplanation } from '../fn/app/app-controller-find-teacher-explanation';
import { AppControllerFindTeacherExplanation$Params } from '../fn/app/app-controller-find-teacher-explanation';
import { appControllerGetAppList } from '../fn/app/app-controller-get-app-list';
import { AppControllerGetAppList$Params } from '../fn/app/app-controller-get-app-list';
import { appControllerGetUsageCount } from '../fn/app/app-controller-get-usage-count';
import { AppControllerGetUsageCount$Params } from '../fn/app/app-controller-get-usage-count';
import { appControllerRemove } from '../fn/app/app-controller-remove';
import { AppControllerRemove$Params } from '../fn/app/app-controller-remove';
import { appControllerUpdate } from '../fn/app/app-controller-update';
import { AppControllerUpdate$Params } from '../fn/app/app-controller-update';
import { AppLabInfo } from '../models/app-lab-info';
import { AppLabTeacherExplanation } from '../models/app-lab-teacher-explanation';
import { AppWithAccounts } from '../models/app-with-accounts';
import { EditorAppInfo } from '../models/editor-app-info';
import { EditorAppLabInfo } from '../models/editor-app-lab-info';

@Injectable({ providedIn: 'root' })
export class AppService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `appControllerFindEditorAppLabList()` */
  static readonly AppControllerFindEditorAppLabListPath = '/app/dummy-method';

  /**
   * Get the list of AppLab.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appControllerFindEditorAppLabList()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerFindEditorAppLabList$Response(params: AppControllerFindEditorAppLabList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EditorAppLabInfo>>> {
    const obs = appControllerFindEditorAppLabList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the list of AppLab.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appControllerFindEditorAppLabList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerFindEditorAppLabList(params: AppControllerFindEditorAppLabList$Params, context?: HttpContext): Observable<Array<EditorAppLabInfo>> {
    const resp = this.appControllerFindEditorAppLabList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<EditorAppLabInfo>>): Array<EditorAppLabInfo> => r.body)
    );
  }

  /** Path part for operation `appControllerGetAppList()` */
  static readonly AppControllerGetAppListPath = '/app/list';

  /**
   * Get the list of all apps.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appControllerGetAppList()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerGetAppList$Response(params?: AppControllerGetAppList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<App>>> {
    const obs = appControllerGetAppList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the list of all apps.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appControllerGetAppList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerGetAppList(params?: AppControllerGetAppList$Params, context?: HttpContext): Observable<Array<App>> {
    const resp = this.appControllerGetAppList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<App>>): Array<App> => r.body)
    );
  }

  /** Path part for operation `appControllerFindEditorAppList()` */
  static readonly AppControllerFindEditorAppListPath = '/app/editorList/{language}';

  /**
   * Get the list of all apps which can be added in the editor.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appControllerFindEditorAppList()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerFindEditorAppList$Response(params: AppControllerFindEditorAppList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EditorAppInfo>>> {
    const obs = appControllerFindEditorAppList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the list of all apps which can be added in the editor.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appControllerFindEditorAppList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerFindEditorAppList(params: AppControllerFindEditorAppList$Params, context?: HttpContext): Observable<Array<EditorAppInfo>> {
    const resp = this.appControllerFindEditorAppList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<EditorAppInfo>>): Array<EditorAppInfo> => r.body)
    );
  }

  /** Path part for operation `appControllerFindSupportedAppList()` */
  static readonly AppControllerFindSupportedAppListPath = '/app/supportedList';

  /**
   * Get the list of supported apps.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appControllerFindSupportedAppList()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerFindSupportedAppList$Response(params?: AppControllerFindSupportedAppList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AppLabInfo>>> {
    const obs = appControllerFindSupportedAppList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the list of supported apps.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appControllerFindSupportedAppList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerFindSupportedAppList(params?: AppControllerFindSupportedAppList$Params, context?: HttpContext): Observable<Array<AppLabInfo>> {
    const resp = this.appControllerFindSupportedAppList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<AppLabInfo>>): Array<AppLabInfo> => r.body)
    );
  }

  /** Path part for operation `appControllerFindTeacherExplanation()` */
  static readonly AppControllerFindTeacherExplanationPath = '/app/teacherExplanation/{language}/{appId}';

  /**
   * Get the teacher explanation for an app.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appControllerFindTeacherExplanation()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerFindTeacherExplanation$Response(params: AppControllerFindTeacherExplanation$Params, context?: HttpContext): Observable<StrictHttpResponse<AppLabTeacherExplanation>> {
    const obs = appControllerFindTeacherExplanation(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the teacher explanation for an app.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appControllerFindTeacherExplanation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerFindTeacherExplanation(params: AppControllerFindTeacherExplanation$Params, context?: HttpContext): Observable<AppLabTeacherExplanation> {
    const resp = this.appControllerFindTeacherExplanation$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AppLabTeacherExplanation>): AppLabTeacherExplanation => r.body)
    );
  }

  /** Path part for operation `appControllerCreate()` */
  static readonly AppControllerCreatePath = '/app';

  /**
   * Create an app.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  appControllerCreate$Response(params: AppControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<App>> {
    const obs = appControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create an app.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  appControllerCreate(params: AppControllerCreate$Params, context?: HttpContext): Observable<App> {
    const resp = this.appControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<App>): App => r.body)
    );
  }

  /** Path part for operation `appControllerFindApp()` */
  static readonly AppControllerFindAppPath = '/app/{appId}';

  /**
   * Get an app.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appControllerFindApp()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerFindApp$Response(params: AppControllerFindApp$Params, context?: HttpContext): Observable<StrictHttpResponse<App>> {
    const obs = appControllerFindApp(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get an app.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appControllerFindApp$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerFindApp(params: AppControllerFindApp$Params, context?: HttpContext): Observable<App> {
    const resp = this.appControllerFindApp$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<App>): App => r.body)
    );
  }

  /** Path part for operation `appControllerRemove()` */
  static readonly AppControllerRemovePath = '/app/{appId}';

  /**
   * deletes an app.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appControllerRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerRemove$Response(params: AppControllerRemove$Params, context?: HttpContext): Observable<StrictHttpResponse<App>> {
    const obs = appControllerRemove(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * deletes an app.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appControllerRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerRemove(params: AppControllerRemove$Params, context?: HttpContext): Observable<App> {
    const resp = this.appControllerRemove$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<App>): App => r.body)
    );
  }

  /** Path part for operation `appControllerUpdate()` */
  static readonly AppControllerUpdatePath = '/app/{appId}';

  /**
   * Update an app.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  appControllerUpdate$Response(params: AppControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<App>> {
    const obs = appControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update an app.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  appControllerUpdate(params: AppControllerUpdate$Params, context?: HttpContext): Observable<App> {
    const resp = this.appControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<App>): App => r.body)
    );
  }

  /** Path part for operation `appControllerFindAppByLanguage()` */
  static readonly AppControllerFindAppByLanguagePath = '/app/{appId}/language/{language}';

  /**
   * Get an app by language.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appControllerFindAppByLanguage()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerFindAppByLanguage$Response(params: AppControllerFindAppByLanguage$Params, context?: HttpContext): Observable<StrictHttpResponse<App>> {
    const obs = appControllerFindAppByLanguage(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get an app by language.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appControllerFindAppByLanguage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerFindAppByLanguage(params: AppControllerFindAppByLanguage$Params, context?: HttpContext): Observable<App> {
    const resp = this.appControllerFindAppByLanguage$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<App>): App => r.body)
    );
  }

  /** Path part for operation `appControllerFindAppWithAccounts()` */
  static readonly AppControllerFindAppWithAccountsPath = '/app/appWithAccounts/{appId}';

  /**
   * Get app with accounts.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appControllerFindAppWithAccounts()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerFindAppWithAccounts$Response(params: AppControllerFindAppWithAccounts$Params, context?: HttpContext): Observable<StrictHttpResponse<AppWithAccounts>> {
    const obs = appControllerFindAppWithAccounts(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get app with accounts.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appControllerFindAppWithAccounts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerFindAppWithAccounts(params: AppControllerFindAppWithAccounts$Params, context?: HttpContext): Observable<AppWithAccounts> {
    const resp = this.appControllerFindAppWithAccounts$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AppWithAccounts>): AppWithAccounts => r.body)
    );
  }

  /** Path part for operation `appControllerGetUsageCount()` */
  static readonly AppControllerGetUsageCountPath = '/app/usageCount/{url}';

  /**
   * Get the number of app usage with the given url.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appControllerGetUsageCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerGetUsageCount$Response(params: AppControllerGetUsageCount$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    const obs = appControllerGetUsageCount(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the number of app usage with the given url.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appControllerGetUsageCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appControllerGetUsageCount(params: AppControllerGetUsageCount$Params, context?: HttpContext): Observable<number> {
    const resp = this.appControllerGetUsageCount$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

}
